<template>
  <v-col
    :cols="columns"
    :sm="smallColumns"
    :style="forPartyEdit ? 'padding: 0px;' : ''"
  >
    <v-form
      ref="form"
      @submit.prevent="submitForm"
    >
      <v-menu
        v-model="menuOpen"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="290px"
      >
        <template #activator="{ on }">
          <v-text-field
            ref="dateField"
            v-model="dateFormatted"
            append-icon="edit_calendar"
            autocomplete="off"
            placeholder="MM/DD/YYYY"
            :disabled="inactive || disabled"
            :filled="!outlined"
            :outlined="outlined"
            :hide-details="hideDetails"
            :label="label"
            :rules="rules.date"
            @on="on"
            @focus="focusOpen"
            @change="parseManuallyEnteredDate"
            @click:append="menuOpen = true"
            @keydown.prevent.enter="setDateToToday"
            @keydown.tab="onTabOut"
          />
        </template>
        <v-date-picker
          v-model="dateInput"
          :min="minDate"
          :max="maxDate"
          @input="_ => closeDatePicker()"
        />
      </v-menu>
    </v-form>
  </v-col>
</template>

<script>
import dateFieldsMixin from '@/mixins/dateFields.js'

export default {
  name: 'BasicDateField',
  mixins: [dateFieldsMixin],

  props: {
    columns: {
      type: Number,
      default: 12,
    },

    date: {
      type: String,
      default: '',
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    forPartyEdit: {
      type: Boolean,
      default: false,
    },

    hideDetails: {
      type: Boolean,
      default: false,
    },

    inactive: {
      type: Boolean,
      default: false,
    },

    label: {
      type: String,
      required: true,
    },

    maxDate: {
      type: String,
      default: '',
    },

    minDate: {
      type: String,
      default: '',
    },

    outlined: {
      type: Boolean,
      default: false,
    },

    // We disable vue/no-unused-properties here because it's actually used in dateFields mixins which eslint can't
    // detect.
    // eslint-disable-next-line vue/no-unused-properties
    required: {
      default: false,
      type: Boolean,
    },

    smallColumns: {
      type: Number,
      default: 6,
    },

    triggerReset: {
      type: Boolean,
      default: false,
    },
  },

  data () {
    return {
      dateFormatted: '',
      dateValidFromInput: true,
      menuOpen: false,
      rules: {
        date: [],
      },
    }
  },

  computed: {
    dateInput: {
      get () {
        return this.date
      },

      set (newDate) {
        // all of the date field components were emitting twice when changed,
        // so adding checks to only emit if date is different
        // but input still needs to be formatted
        this.dateFormatted = this.formatDate(newDate)
        if (newDate !== this.date) this.$emit('update-date', newDate)
      },
    },
  },

  watch: {
    triggerReset (val) {
      if (val) this.$refs.form.reset()
    },
  },

  created () {
    this.dateFormatted = this.formatDate(this.dateInput)
    this.addBasicValidation()
  },

  methods: {
    closeDatePicker () {
      this.resetValidation(true)
      this.menuOpen = false
    },

    onTabOut () {
      this.menuOpen = false
      this.$emit('tab-out')
    },

    setDateToToday () {
      const today = new Date()
      const dd = String(today.getDate()).padStart(2, '0')
      const mm = String(today.getMonth() + 1).padStart(2, '0')
      const yyyy = today.getFullYear()
      this.dateInput = `${yyyy}-${mm}-${dd}`
    },

    submitForm () {
      this.$emit('submit')
    },
  },
}
</script>
